import React from 'react';
import { func, bool } from 'prop-types';
import MenuItem from 'material-ui/MenuItem';
import DropDownTitled from './DropDownTitled';
import { Precision } from '../constants';
import { Precision as IPrecision } from '../models';

const PrecisionSelector = ({
  value,
  timespanInterval,
  compareInterval,
  onChange,
  disabled,
}) => (
  <DropDownTitled
    value={value}
    title="Data precision:"
    onChange={(e, i, precision) => onChange(precision)}
    disabled={disabled}
    iconStyle={{ fill: 'rgba(0,0,0,.87)' }}
  >
    <MenuItem value={Precision.MONTHLY} primaryText="Monthly" />
    <MenuItem value={Precision.YEARLY} primaryText="Yearly" />
  </DropDownTitled>
);

PrecisionSelector.propTypes = {
  value: IPrecision.isRequired,
  onChange: func.isRequired,
  disabled: bool,
};

export default PrecisionSelector;



// WEBPACK FOOTER //
// ./src/components/PrecisionSelector.jsx